export interface TemplateFilter {
  filterKey: TemplateVisibilityValues;
  label: string;
}

export const VISIBILITY_FILTERS: TemplateFilter[] = [
  {
    filterKey: 'ALL_USERS',
    label: 'templateManager.filters.visibility.allUsers',
  },
  {
    filterKey: 'DEVELOPER',
    label: 'templateManager.filters.visibility.developer',
  },
  {
    filterKey: 'ARCHIVED',
    label: 'templateManager.filters.visibility.archived',
  },
];

export const DEFAULT_CHECKED_VISIBILITY_FILTERS: TemplateVisibilityValues[] = [
  'ALL_USERS',
  'ARCHIVED',
  'DEVELOPER',
];
